import '../css/test.css';
import { userModel } from "../index.js";
const TestView = ({timer, question, onGreenS, onRedS, onBlueS, onYellowS, onPurpleS, onBlackS, onWhiteS, onPinkS,
    onGreenC, onRedC, onBlueC, onYellowC, onPurpleC, onBlackC, onWhiteC, onPinkC, onNext, onStart, onRepeat, nextQuestion, showRepeat, start}) =>
    /** Start page with login and sign up*/
    <div className="wrapper">
        {userModel.secondTest === false ? <h1>Part 1</h1>
        : <h1>Part 2</h1>}
        <h2>{timer}</h2>
        <h3>{question}</h3>
        <div className = "buttonsSquares">
            <button className = "green" onClick={() => onGreenS()}>GREEN</button>
            <button className = "red" onClick={() => onRedS()}>RED</button>
            <button className = "blue" onClick={() => onBlueS()}>BLUE</button>
            <button className = "yellow" onClick={() => onYellowS()}>YELLOW</button>
            <button className = "purple"onClick={() => onPurpleS()}>PURPLE</button>
            <button className = "pink" onClick={() => onPinkS()}>PINK</button>
            <button className = "black" onClick={() => onBlackS()}>BLACK</button>
            <button className = "white" onClick={() => onWhiteS()}>WHITE</button>
        </div>
        <div className = "buttonsCircles">
            <button className = "white" onClick={() => onWhiteC()}>WHITE</button>
            <button className = "pink" onClick={() => onPinkC()}>PINK</button>
            <button className = "yellow" onClick={() => onYellowC()}>YELLOW</button>
            <button className = "green" onClick={() => onGreenC()}>GREEN</button>
            <button className = "black" onClick={() => onBlackC()}>BLACK</button>
            <button className = "purple"onClick={() => onPurpleC()}>PURPLE</button>
            <button className = "blue" onClick={() => onBlueC()}>BLUE</button>
            <button className = "red" onClick={() => onRedC()}>RED</button>
        </div>
        {start === false && <button className = "next" onClick={() => onStart()}>START</button>}
        {nextQuestion === true && <button className = "next" onClick={() => onNext()}>NEXT INSTRUCTION</button>}
        {showRepeat === true && <button className = "next" onClick={() => onRepeat()}>REPEAT INSTRUCTION</button>}
    </div>;

export {TestView};
